import { pcos } from './initial/flow';
import pcosFollowup from './followup';

const PCOSFlows = {
  pcos,
  pcosFollowup
};

export default PCOSFlows;
